import React from "react";
import { Pressable, Text, View } from "react-native";

import { PrimaryButton } from "../../../../common/native";
import { ADMIN_TOKENS } from "../../../../../styles/adminTokens";

type CallControlsProps = {
  isHangupSubmitting: boolean;
  isMuted: boolean;
  onHangup: () => void;
  onToggleMute: () => void;
};

const CallControls: React.FC<CallControlsProps> = ({
  isHangupSubmitting,
  isMuted,
  onHangup,
  onToggleMute,
}) => {
  return (
    <View style={{ flexDirection: "row", gap: ADMIN_TOKENS.spacing.sm }}>
      <PrimaryButton
        text={isHangupSubmitting ? "Hanging up..." : "Hang Up"}
        onPress={onHangup}
        loading={isHangupSubmitting}
        disabled={isHangupSubmitting}
        fullWidth
        style={{ backgroundColor: ADMIN_TOKENS.color.errorTextStrong }}
      />
      <Pressable
        onPress={onToggleMute}
        accessibilityRole="button"
        style={({ pressed }) => ({
          minHeight: 44,
          minWidth: 120,
          borderRadius: ADMIN_TOKENS.radius.md,
          borderWidth: ADMIN_TOKENS.borderWidth.sm,
          borderColor: pressed
            ? ADMIN_TOKENS.color.accent
            : ADMIN_TOKENS.color.border,
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: ADMIN_TOKENS.color.surface,
          paddingHorizontal: ADMIN_TOKENS.spacing.md,
        })}
      >
        <Text
          style={{
            color: ADMIN_TOKENS.color.textPrimary,
            fontFamily: ADMIN_TOKENS.font.medium,
          }}
        >
          {isMuted ? "Unmute" : "Mute"}
        </Text>
      </Pressable>
    </View>
  );
};

export default CallControls;
